import { MessageMetaArray } from "@sendbird/chat/message";

/** Sendbird UIKit treats a file as a voice note only with this mime param. */
export const SENDBIRD_VOICE_MIME = "audio/m4a;sbu_type=voice";
export const SENDBIRD_VOICE_FILENAME = "Voice_message.m4a";

export function isIosPlayableAudio(mimeType: string): boolean {
  const type = mimeType.toLowerCase();
  return (
    type.includes("mp4") ||
    type.includes("m4a") ||
    type.includes("mpeg") ||
    type.includes("mp3") ||
    type.includes("aac")
  );
}

export function wrapVoiceFile(blob: Blob): File {
  return new File([blob], SENDBIRD_VOICE_FILENAME, {
    type: SENDBIRD_VOICE_MIME,
    lastModified: Date.now(),
  });
}

export function voiceMessageMetaArrays(durationMs: number): MessageMetaArray[] {
  return [
    new MessageMetaArray({
      key: "KEY_VOICE_MESSAGE_DURATION",
      value: [String(Math.max(0, Math.round(durationMs)))],
    }),
    new MessageMetaArray({
      key: "KEY_INTERNAL_MESSAGE_TYPE",
      value: ["voice/m4a"],
    }),
  ];
}

export async function prepareAttentionVoiceFile(
  blob: Blob,
  transcodeToM4a: (input: Blob) => Promise<Blob>,
): Promise<File> {
  const source = isIosPlayableAudio(blob.type)
    ? blob
    : await transcodeToM4a(blob);
  return wrapVoiceFile(source);
}
